import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '../divider/Divider';
import { UploadMethodsProps } from './CreateUploadMethod';
import { UploadMethodComponent } from './partials/UploadMethodComponent';
import { UploadMethodsButtons } from './partials/UploadMethodsButtons';
import styles from './UploadMethods.module.scss';

export const UploadMethods = ({
    className, methods,
    setActiveSource,
    close, onUpload
}: Props) => {

    const { t } = useTranslation();
    const anyNonDefaultSources = Object.keys(methods)
        .filter(key => key !== 'Dropzone')
        .length > 0;

    return (
        <div className={className}>
            <UploadMethodComponent
                method={methods['Dropzone']}
                close={close}
                onUpload={onUpload} />

            {anyNonDefaultSources && (
                <>
                    <Divider className={styles.divider}>
                        {t('commons.or')}
                    </Divider>

                    <UploadMethodsButtons methods={methods} openSource={setActiveSource} />
                </>
            )}
        </div>
    );
};

export type Props = {
    className?: string;
    close: () => void;
    methods: UploadMethodsProps;
    setActiveSource: (key: keyof UploadMethodsProps) => void;
    onUpload?: () => void;
};